module.exports = __webpack_public_path__ + "static/media/03.b7c8d6a4.png";